import { LiveVideoSource, LiveVideoState } from '@/signalr';
import type {
  Attachment,
  CollaborationState,
  EedLiveVideo,
  Incident,
  LiveVideo,
  Position,
  PositionSource,
} from '@/signalr';

export function filterPositionsBySource(
  positions: readonly Position[],
  source: PositionSource | null | undefined,
): Position[] {
  if (source != null) {
    return positions.filter((position) => position.positionSource === source);
  }

  return [...positions];
}

export function getLastPositionBySource(
  incident: Incident,
  source: PositionSource | null | undefined,
): Position | null {
  if (source == null) {
    return incident.lastPosition;
  }

  return incident.lastPositionBySource.find((position) => position.positionSource === source) ?? null;
}

export function psapIdEquals(a: string, b: string): boolean {
  return a.toLowerCase() === b.toLowerCase();
}

export function getPsapView(incident: Incident, psapId: string) {
  return incident.psapViews.find((view) => psapIdEquals(view.psapId, psapId)) ?? null;
}

export function getCollaborationState(incident: Incident, psapId: string): CollaborationState | null {
  return getPsapView(incident, psapId)?.collaborationState ?? null;
}

export function isSupervisorOf(incident: Incident, psapId: string): boolean {
  return getPsapView(incident, psapId)?.isSupervisor ?? false;
}

export function isEedLiveVideo(liveVideo: LiveVideo | null): liveVideo is EedLiveVideo {
  return liveVideo?.source === LiveVideoSource.Eed;
}

export function hasActiveVideo(incident: Incident): boolean {
  return incident.videoState === LiveVideoState.Active;
}

export function isVideoAttachment(attachment: Attachment): boolean {
  return attachment.mimeType.toLowerCase().startsWith('video/');
}

export function medicDataAge(yearOfBirth: number | null, createdTimeUtc: string): number | null {
  return yearOfBirth != null ? new Date(createdTimeUtc).getFullYear() - yearOfBirth : null;
}

export function orderShowFirst<T>(source: readonly T[], predicate: (item: T) => boolean): T[] {
  return [...source].sort((a, b) => Number(!predicate(a)) - Number(!predicate(b)));
}
